<div class="modal-header pt-4">
  <h5 class="modal-title ">{{ title }} </h5>
</div>


<div class="modal-body pt-2">

  <p [innerHTML]="body"></p>


</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary banner-button modal-banner-button secondary" data-dismiss="modal"
    (click)="onCancel()">CANCELAR</button>
  <button type="button" class="btn btn-primary banner-button modal-banner-button" ngbAutofocus (click)="onOk()">ACEPTAR</button>

</div>